import { PromptFormDialog } from '../PromptFormDialog';
import { usePromptLibrary } from '../PromptLibraryProvider';
export function EditPrompt() {
    const { onClose, setView, setCurrentPromptID, currentPrompt } = usePromptLibrary();
    const handleCloseFormDialog = () => {
        setCurrentPromptID(undefined);
        setView('library');
        onClose();
    };
    return <PromptFormDialog onClose={handleCloseFormDialog} initialValues={currentPrompt}/>;
}
